export default __webpack_public_path__ + "static/media/2_0064.ce090e06.webp";